import axios from 'axios';
import {
  TResponseLedger,
  TLedger,
  TLedgerPicturesData,
  TLedgerPictur
} from '../types/Ledger';
import { SetterOrUpdater } from 'recoil';
import {
  TPicture,
  TFolderPicture,
  TFoldrtList
} from '../types/cloudStorage/CloudFileList';
import { getPictureFolder, getPictureList } from '../apicalls/cloudFile';
import { checkResData } from '../utils/common';
import { SnackbarKey, OptionsObject, SnackbarMessage } from 'notistack';
import { downloadPictureById } from './cloud/cloudPicture';

export const getFolderList = async (
  constructId: number,
  enqueueSnackbar: (
    message: SnackbarMessage,
    options?: OptionsObject | undefined
  ) => SnackbarKey,
  setFolderList: SetterOrUpdater<TFolderPicture[]>
) => {
  const folderFile: TFolderPicture[] = [];

  const param = `construct_id=${constructId}`;

  await getPictureFolder(param)
    .then(async resData => {
      await checkResData(resData, enqueueSnackbar).then(async (data: any) => {
        const folderList: TFoldrtList[] = data.data;
        for (let i = 0; folderList.length > i; i++) {
          const folder: TFoldrtList = folderList[i];
          await getPictureList(folder.id, param).then(async (resData: any) => {
            await checkResData(resData, enqueueSnackbar).then(
              async (data: any) => {
                const folderData: TFolderPicture = {
                  id: folder.id,
                  name: folder.name,
                  construct_id: folder.construct_id,
                  construct_name: folder.construct_name,
                  file_count: folder.file_count,
                  pictures: data.data
                };
                folderFile.push(folderData);
              }
            );
          });
        }
      });
    })
    .then(() => {
      setFolderList(folderFile);
    });
};

export const createLedger = (data: any) => {
  return axios
    .post('/api/v1/create/photo_ledger', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const resizeImage = (file: any) => {
  return axios
    .post(
      '/api/v1/resize/image',
      {
        upload_file: file
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getLedgerList = (param: string) => {
  return axios
    .get(`/api/v1/get/photo_ledger/list${param}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getLedger = (photoLedgerId: number) => {
  return axios
    .get(`/api/v1/get/photo_ledger?photo_ledger_id=${photoLedgerId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(async response => {
      const data: TResponseLedger = response.data.data;
      return await arrangementData(data);
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copyLedger = (photoLedgerId: number | undefined) => {
  return axios
    .get(
      `/api/v1/copy/photo_ledger?photo_ledger_id=${
        photoLedgerId ? photoLedgerId : 0
      }`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(async response => {
      return true;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateLedger = (data: any) => {
  return axios
    .post('/api/v1/update/photo_ledger', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const downloadLedger = (photoLedgerId: number) => {
  return axios
    .get(`/api/v1/get/photo_ledger?photo_ledger_id=${photoLedgerId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(async response => {
      const data: TResponseLedger = response.data.data;
      return await setImgData(await arrangementData(data));
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteLedger = (photoLedgerId: number | undefined) => {
  return axios
    .post(
      `/api/v1/delete/photo_ledger?photo_ledger_id=${
        photoLedgerId ? photoLedgerId : 0
      }`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(async response => {
      return true;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getClient = (constructId: number) => {
  return axios
    .get(`/api/v1/get/client?construct_id=${constructId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(async response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateRotatePicture = (
  pictureId: number,
  rotationAngle: number
) => {
  return axios
    .post(
      `/api/v1/update/rotate_picture?rotation_angle=${rotationAngle}&picture_id=${pictureId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(async response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

const arrangementData = async (data: TResponseLedger) => {
  const ledgerPicturesData: TLedgerPicturesData[] = data.ledger_pictures_data
    ? data.ledger_pictures_data
    : [];

  const formDefaultValue: TLedger = {
    id: data.id,
    construct_id: data.construct_id,
    construct_name: data.construct_name,
    title: data.title,
    created_at: data.created_at,
    created_by: data.created_by,
    updated_at: data.updated_at,
    count: ledgerPicturesData.length,
    pictures: []
  };

  const ledgerPictures: TLedgerPictur[] = [];

  for (let i = 0; ledgerPicturesData.length > i; i++) {
    const item: TLedgerPicturesData = ledgerPicturesData[i];
    ledgerPictures.push({
      id: item.id,
      photo_ledger_id: item.photo_ledger_id,
      picture_id: item.picture_id,
      sort_order: item.sort_order,
      shooting_date: item.shooting_date,
      place: item.place,
      note: item.note,
      created_at: item.created_at,
      updated_at: item.updated_at,
      picture_src: ''
    });
  }

  formDefaultValue.pictures = ledgerPictures;

  return formDefaultValue;
};

const setImgData = async (formDefaultValue: TLedger) => {
  const ledgerPictures = formDefaultValue.pictures;

  if (!ledgerPictures || (ledgerPictures && ledgerPictures.length <= 0)) {
    return formDefaultValue;
  }

  for (let i = 0; ledgerPictures.length > i; i++) {
    await downloadPictureById(ledgerPictures[i].picture_id).then(
      (data: any) => {
        const image_data = data.data.replace(/^.*,/, '');
        ledgerPictures[
          i
        ].picture_src = `data:${data.file_format};base64,${image_data}`;
      }
    );
  }

  return formDefaultValue;
};
